import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/articles';

export default function SeoArticlesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-3">
            Artykuły SEO
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Poradniki i artykuły Kakobuy Spreadsheet
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Przeczytaj nasze szczegółowe poradniki o Kakobuy – od bezpieczeństwa, przez porady zakupowe, po rankingi najlepszych produktów.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group flex flex-col bg-background-50 rounded-2xl border border-background-200/70 hover:border-primary-300 hover:shadow-sm transition-all overflow-hidden cursor-pointer no-underline"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-primary-700 text-xs font-semibold rounded-full">
                  {article.tag}
                </span>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4 flex-1 line-clamp-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500 pt-3 border-t border-background-200/70">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                  <span className="flex items-center gap-1 ml-auto text-primary-500 font-medium">
                    Czytaj
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer no-underline"
          >
            <i className="ri-shopping-cart-line text-lg"></i>
            Przejdź do Kakobuy Spreadsheet
          </a>
        </div>
      </div>
    </section>
  );
}